import { SelectProps } from 'antd/lib'
import { Dispatch, useEffect, useMemo } from 'react'

import { useNotificationsServiceGetEventsListEndpoint } from 'src/api/queries'
import { Placeholder } from 'src/api/requests/models/Placeholder'
import { Select } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  setPlaceholders: Dispatch<Placeholder[]>
} & SelectProps

export const EventsSelect = ({ setPlaceholders, ...props }: Props) => {
  const { t } = useLocales()

  const { data, isLoading } = useNotificationsServiceGetEventsListEndpoint()

  const options = useMemo(
    () =>
      data?.data?.map((item) => ({
        value: item.id,
        label: item.displayName
      })),
    [data]
  )

  useEffect(() => {
    const item = data?.data?.find((item) => item.id === props.value)

    if (item) {
      setPlaceholders(item.placeholders ?? [])
    }
  }, [props, data])

  return (
    <Select
      options={options}
      popupMatchSelectWidth
      loading={isLoading}
      placeholder={t('notification_templates.event')}
      {...props}
    />
  )
}
